import PropTypes from 'prop-types';
import React from 'react';

import { inject } from 'mobx-react';
import useMaybeExternalLink from '../../../hooks/navigation/useMaybeExternalLink';
import CustomNavigationLink from '../../../models/CustomNavigationLink';
import Menu from '../../../models/Menu';
import { modelOf } from '../../../prop-types';
import LocationContext from '../../../services/LocationContext';
import NavigationEntity from '../../../types/NavigationEntity';
import ButtonLink from '../../common/ButtonLink';
import MaybeExternalLink from '../../common/MaybeExternalLink';

const MobileNavigationButtonLink = ({
  locationContext,
  child,
  onSelectItem,
  currentPath,
  onClick,
  children,
}) => {
  const { host } = locationContext;
  const type = child.type ? child.type : null;

  const [linkPath] = useMaybeExternalLink({
    path: child.path,
    type,
    host,
  });

  if (
    (child.children && child.children.length > 0) ||
    (child.path && child.path === '#')
  ) {
    return (
      <ButtonLink
        href={linkPath}
        onClick={() => onSelectItem(currentPath)}
        type={type}
      >
        {children}
      </ButtonLink>
    );
  }

  return (
    <MaybeExternalLink
      // So we don't break existing styles
      className="ButtonLink"
      to={child.path}
      type={type}
      onClick={onClick}
      tabIndex={0}
      role="button"
      isNoFollowLink
    >
      {children}
    </MaybeExternalLink>
  );
};

MobileNavigationButtonLink.propTypes = {
  locationContext: PropTypes.instanceOf(LocationContext).isRequired,
  child: PropTypes.oneOfType([
    modelOf(NavigationEntity),
    modelOf(CustomNavigationLink),
    modelOf(Menu),
    /**
     * Fallback to cover static navigation entities,
     * sections and categories,
     * other static objects that has same properties
     */
    PropTypes.object,
  ]).isRequired,
  currentPath: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  onSelectItem: PropTypes.func.isRequired,
};

export default inject('locationContext')(MobileNavigationButtonLink);
